// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Invoice } from './invoice';
import { Load } from './load';
import { Product } from './product';
import { ProductUnitOfMeasure } from './product-unit-of-measure';

/// <code-import> Place custom imports between <code-import> tags
import { Utility } from '../utility';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get lineTotal() {
        return Utility.round(this.quantity * this.price, 2);
    }

    get tax() {
        if (this.isTaxable) return Utility.round(Utility.SalesTaxRate * this.quantity * this.price, 2);
        else return 0;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  invoiceId!: number;
  isAdditive!: boolean;
  isMisc!: boolean;
  isTaxable!: boolean;
  lineNumber!: number;
  loadId?: number;
  notes?: string;
  parentLineId?: number;
  partNumber?: string;
  price!: number;
  productId?: number;
  quantity!: number;
  ticketNumber?: string;
  unit?: string;
  unitOfMeasureId?: number;
  childrenLines!: InvoiceLine[];
  invoice!: Invoice;
  load!: Load;
  parentLine!: InvoiceLine;
  product!: Product;
  unitOfMeasure!: ProductUnitOfMeasure;
}

